export default __webpack_public_path__ + "static/img/sign-sun.a6ede0d.png";